import React from "react";
import { Controller } from "react-hook-form";
import { Form, Transfer } from "antd";

const IndexTransferElement = (props) => {
  const { IndexData, locale, listStyle, control, solutionID } = props;

  return (
    <Form.Item wrapperCol={{ span: 14, offset: 5 }}>
      <Controller
        control={control}
        name="indexIds"
        render={({ field: { onChange, value } }) => (
          <Transfer
            style={{ marginTop: "20px" }}
            showSearch
            disabled={solutionID === undefined}
            dataSource={IndexData}
            rowKey={(record) => record._id}
            render={(item) => item.name}
            listStyle={listStyle}
            optionFilterProp="name"
            filterOption={(input, option) => {
              return (
                option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
            targetKeys={value}
            onChange={(nextTargetKeys) => {
              onChange(nextTargetKeys);
            }}
            locale={locale}
          />
        )}
      />
    </Form.Item>
  );
};

export default IndexTransferElement;
